import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import DeleteSpaceFormModal from 'src/features/spaces/components/form/DeleteSpaceFormModal';
import UpdateSpaceFormModal from 'src/features/spaces/components/form/UpdateSpaceFormModal';
import { Space } from 'src/features/spaces/utils/types';
import { spacesMessages } from 'src/features/spaces/utils/messages';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellSpaceActions({ row }: CellContext<Space, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateSpaceFormModal
                        selectedSpace={row.original}
                        semantics={{ entryName: formatMessage(spacesMessages.space).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateSpaceFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteSpaceFormModal
                        selectedSpace={row.original}
                        semantics={{ entryName: formatMessage(spacesMessages.space).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteSpaceFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
